import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Boxes, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Input } from "@/components/erp/ui";

const PasswordLogin = () => {
  const { checkAuth } = useAuth();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { const { data } = await api.post("/auth/password-login", f); await checkAuth(); }
    catch (x) { const d = x.response?.data?.detail; setErr(typeof d === "string" ? d : "Gagal masuk"); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="password-login-form">
      <Input data-testid="login-email" type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required />
      <Input data-testid="login-password" type="password" placeholder="Password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required />
      {err && <p data-testid="login-error" className="text-sm text-rose-600">{err}</p>}
      <button data-testid="password-login-btn" disabled={busy} className="w-full border border-slate-900 rounded-xl py-3 font-medium hover:bg-slate-50 transition-colors disabled:opacity-50">{busy ? "Memproses..." : "Masuk dengan Password"}</button>
      <p className="text-xs text-center"><a href="/forgot-password" data-testid="forgot-link" className="text-sky-600 hover:underline">Lupa password?</a></p>
      {new URLSearchParams(window.location.search).get("reset") && <p data-testid="reset-done" className="text-xs text-emerald-600 text-center">Password berhasil diubah. Silakan masuk.</p>}
    </form>
  );
};

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/app", { replace: true });
  }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-slate-900 text-white p-12 grid-bg">
        <div className="flex items-center gap-2 font-head font-bold text-xl">
          <Boxes className="text-sky-400" /> FOMU 3D <span className="text-sky-400">PRINT</span>
        </div>
        <div>
          <h1 className="font-head text-4xl font-bold leading-tight">One Data.<br/>Satu Sistem.<br/>Dari Booking sampai Payroll.</h1>
          <p className="text-slate-400 mt-4 max-w-md">Platform operasional terintegrasi untuk perusahaan 3D Printing — CRM, Quotation, Work Order, Produksi, Stock, HR & Finance dalam satu alur.</p>
        </div>
        <p className="text-slate-500 text-sm font-mono">Premium Industrial Technology</p>
      </div>
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm anim-up">
          <div className="lg:hidden flex items-center gap-2 font-head font-bold text-xl mb-8">
            <Boxes className="text-sky-500" /> FOMU 3D PRINT
          </div>
          <h2 className="font-head text-2xl font-bold">Masuk ke Workspace</h2>
          <p className="text-slate-500 text-sm mt-2 mb-8">Gunakan akun Google atau email & password tim Anda untuk mengakses ERP internal.</p>
          <button
            data-testid="google-login-btn"
            onClick={login}
            className="w-full flex items-center justify-center gap-3 bg-slate-900 text-white rounded-xl py-3.5 font-medium hover:bg-slate-800 transition-colors"
          >
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5 bg-white rounded-full p-0.5" />
            Lanjut dengan Google <ArrowRight className="w-4 h-4" />
          </button>
          <div className="flex items-center gap-3 my-6 text-xs text-slate-400"><span className="flex-1 h-px bg-slate-200" />atau<span className="flex-1 h-px bg-slate-200" /></div>
          <PasswordLogin />
          <a href="/" className="block text-center text-sm text-slate-500 mt-6 hover:text-slate-900">← Kembali ke beranda</a>
        </div>
      </div>
    </div>
  );
}
